module.exports = __webpack_public_path__ + "img/vegetable-cucumbers-350x184.512dbcf7.jpg";